/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 15.0002V19.5002C6 20.3287 6.67157 21.0002 7.5 21.0002V21.0002C8.32843 21.0002 9 20.3287 9 19.5002V15.0002M20 7.99976V7.99976C21.6569 7.99976 23 9.3429 23 10.9998V10.9998C23 12.6566 21.6569 13.9998 20 13.9998V13.9998"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 7H6C3.79086 7 2 8.79086 2 11V11C2 13.2091 3.79086 15 6 15H10M10 7V15M10 7L14.9648 3.52437C16.5944 2.38361 17.4092 1.81322 18.0874 1.84289C18.678 1.86872 19.2269 2.1545 19.5867 2.6235C20 3.1621 20 4.15669 20 6.14586V15.8537C20 17.8427 20 18.8372 19.5868 19.3758C19.2269 19.8448 18.6781 20.1306 18.0875 20.1564C17.4093 20.1861 16.5945 19.6158 14.965 18.4753L10 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M10 6.99951L14.9649 3.52407C16.5945 2.38339 17.4092 1.81306 18.0874 1.84273C18.678 1.86858 19.2269 2.15436 19.5868 2.62337C20 3.16196 20 4.15651 20 6.14561V15.8534C20 17.8425 20 18.8371 19.5868 19.3757C19.2269 19.8447 18.678 20.1304 18.0874 20.1563C17.4092 20.186 16.5945 19.6156 14.9649 18.475L10 14.9995V6.99951Z"
				fill="currentColor"
			/>
			<path
				d="M10 7H6C3.79086 7 2 8.79086 2 11V11C2 13.2091 3.79086 15 6 15H10M10 7V15M10 7L14.9648 3.52437C16.5944 2.38361 17.4092 1.81322 18.0874 1.84289C18.678 1.86872 19.2269 2.1545 19.5867 2.6235C20 3.1621 20 4.15669 20 6.14586V8M10 15L14.965 18.4753C16.5945 19.6158 17.4093 20.1861 18.0875 20.1564C18.6781 20.1306 19.2269 19.8448 19.5868 19.3758C20 18.8372 20 17.8427 20 15.8537V14M6 15V19.5C6 20.3284 6.67157 21 7.5 21V21C8.32843 21 9 20.3284 9 19.5V15M20 8V8C21.6569 8 23 9.34315 23 11V11C23 12.6569 21.6569 14 20 14V14M20 8V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M20.75 4.62164C20.75 2.70623 20.75 1.74852 20.3654 1.22163C19.9971 0.717142 19.4142 0.413686 18.7897 0.401276C18.1375 0.388314 17.3529 0.937523 15.7838 2.03594L12.1149 4.60413C11.6153 4.95387 11.3655 5.12874 11.1849 5.3557C11.025 5.55666 10.9053 5.78654 10.8324 6.03277C10.75 6.31085 10.75 6.61579 10.75 7.22567L10.75 14.7745C10.75 15.3843 10.75 15.6893 10.8324 15.9674C10.9053 16.2136 11.025 16.4435 11.1849 16.6444C11.3655 16.8714 11.6153 17.0463 12.1149 17.396L15.7837 19.9641C17.3529 21.0626 18.1375 21.6118 18.7898 21.5988C19.4142 21.5864 19.997 21.283 20.3653 20.7785C20.75 20.2516 20.75 19.2939 20.75 17.3784V14.3005C20.75 14.1128 20.8438 13.9375 21 13.8334L21.752 13.3321C22.5317 12.8122 23 11.9371 23 11C23 10.0629 22.5316 9.18777 21.7519 8.66795L21 8.16672C20.8438 8.0626 20.75 7.88731 20.75 7.6996V4.62164Z"
				fill="currentColor"
			/>
			<path
				d="M9.00758 6.25006C9.14146 6.25006 9.25 6.3586 9.25 6.49249V19.8751C9.25 20.9106 8.41053 21.7501 7.375 21.7501C6.33947 21.7501 5.5 20.9106 5.5 19.8751V15.7501C3.15279 15.7501 1.25 13.8473 1.25 11.5001L1.25 11.0001C1.25 8.37671 3.37665 6.25006 6 6.25006H9.00758Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M10 15.0002H6C3.79086 15.0002 2 13.2093 2 11.0002V11.0002C2 8.79104 3.79086 7.00017 6 7.00017H10L13 4.89989M10 15.0002V10.0002M10 15.0002L13.7061 17.5942C16.4669 19.5267 17.8472 20.493 18.9236 19.9325C20 19.3721 20 17.6872 20 14.3173V7.68252C20 4.31262 20 2.62767 18.9236 2.06725C18.1545 1.66679 17.2301 2.04586 15.7578 3M6 15.0002V19.5002C6 20.3286 6.67157 21.0002 7.5 21.0002V21.0002C8.32843 21.0002 9 20.3286 9 19.5002V17.5001M20 8.00017V8.00017C21.6569 8.00017 23 9.34332 23 11.0002V11.0002C23 12.657 21.6569 14.0002 20 14.0002V14.0002V8.00017Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10 7.00024H6C3.79086 7.00024 2 8.79111 2 11.0002V11.0002C2 13.2094 3.79086 15.0002 6 15.0002H10M10 7.00024V15.0002M10 7.00024L14.9648 3.52462C16.5944 2.38385 17.4092 1.81347 18.0874 1.84313C18.678 1.86896 19.2269 2.15474 19.5867 2.62375C20 3.16235 20 4.15693 20 6.1461V8.00024M10 15.0002L14.965 18.4755C16.5945 19.6161 17.4093 20.1864 18.0875 20.1567C18.6781 20.1308 19.2269 19.845 19.5868 19.376C20 18.8374 20 17.8429 20 15.8539V14.0002M6 15.0002V19.5002C6 20.3287 6.67157 21.0002 7.5 21.0002V21.0002C8.32843 21.0002 9 20.3287 9 19.5002V15.0002M20 8.00024V8.00024C21.6569 8.00024 23 9.34339 23 11.0002V11.0002C23 12.6571 21.6569 14.0002 20 14.0002V14.0002M20 8.00024V14.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M20.75 4.70567C20.75 2.71657 20.75 1.72202 20.3368 1.18342C19.9769 0.714422 19.428 0.428636 18.8374 0.402793C18.1592 0.373116 17.3445 0.943453 15.7149 2.08413L12.1149 4.60413C11.6153 4.95387 11.3655 5.12874 11.1849 5.3557C11.025 5.55666 10.9053 5.78654 10.8324 6.03277C10.75 6.31085 10.75 6.61579 10.75 7.22567L10.75 14.7745C10.75 15.3843 10.75 15.6893 10.8324 15.9674C10.9053 16.2136 11.025 16.4435 11.1849 16.6444C11.3655 16.8714 11.6153 17.0463 12.1149 17.396L15.7149 19.916C17.3445 21.0567 18.1592 21.627 18.8374 21.5973C19.428 21.5715 19.9769 21.2857 20.3368 20.8167C20.75 20.2781 20.75 19.2836 20.75 17.2945L20.75 4.70567Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.25 6.49243C9.25 6.35854 9.14146 6.25 9.00758 6.25L6 6.25C3.37665 6.25 1.25 8.37665 1.25 11L1.25 11.5C1.25 13.8472 3.15279 15.75 5.5 15.75L5.5 19.875C5.5 20.9105 6.33947 21.75 7.375 21.75C8.41053 21.75 9.25 20.9105 9.25 19.875L9.25 6.49243ZM21.752 13.332L20.75 14L20.75 8L21.7519 8.66789C22.5316 9.18771 23 10.0628 23 11C23 11.9371 22.5317 12.8122 21.752 13.332Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
